module.exports = {
  "dof-slider-scale": {
    "position": "absolute",
    "whiteSpace": "nowrap",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "20",
    "fontWeight": "400"
  },
  "dof-slider-scale--mid": {
    "transform": "translate(-50%, 0px)"
  },
  "dof-slider-scale--first": {
    "transform": "translate(-50%, 0px)"
  },
  "dof-slider-scale--last": {
    "transform": "translate(50%, 0px)"
  },
  "colmoFont": {
    "fontFamily": "COLMO-Mono-Regular",
    "fontSize": "24"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5b637e77!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-slider-scale/index.vue
// module id = 487
// module chunks = 0 1